export function contentVideo() {
    $(".video-holder .play-video-button").on("click", function (e) {
        e.preventDefault();
        let parent = $(this).parent();
        parent.addClass("video-play");
        let video = parent.find("video");
        video.get(0).play();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contentVideo.js